<template>
  <div class="personnel-on-duty-schedule-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">出入口设备：</span>
        </div>
        <el-select v-model="formData.deviceCode" size="small" style="width: 280px">
          <el-option v-for="item in parkingAccessManageList" :key="item.code"
                     :label="item._label" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">值班人员：</span>
        </div>
        <el-select v-model="formData.personCode" filterable remote reserve-keyword size="small" style="width: 280px" :remote-method="remoteMethod" placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班次：</span>
        </div>
        <el-select v-model="formData.routeCode" size="small" style="width: 280px">
          <el-option v-for="item in parkingEmergencyRouteList" :key="item.code"
                     :label="item.routeName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from 'js-md5'
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../components/Text/TextTitle'
import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../../components/Button/ButtonCancel'
import {api} from '../../../api/ParkingService'
import {errorHandler} from '../../../../utils/errorHandler'
import {nError, nSuccess} from '../../../../utils/notice'
import {pattern} from '../../../../utils/regular'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'personnel-on-duty-schedule-add',
  data () {
    return {
      breadcrumb: [
        {value: "智慧停车", name: "parking-device-management"},
        {value: "排班管理"}
      ],
      mainTitle: '添加排班',
      subheading: '',

      parkingAccessManageList: [],
      parkingEmergencyRouteList: [],
      responsiblePersonList: [],
      formData: {
        deviceName: '',
        deviceCode: '',
        personCode: '',
        personName: '',
        personPhone: '',
        routeCode: '',
        routeName: '',
      }
    }
  },
  created () {
    this.remoteMethod()
    this.getParkingAccessManageList()
    this.getParkingEmergencyRouteList()
  },
  methods: {
    remoteMethod (query) {
      this.getResponsiblePerson(query)
    },
    // 查询授权对象
    getResponsiblePerson (searchKey) {
      this.$axios.post(api.getResponsiblePersonList, {
        searchKey: searchKey || ''
      })
        .then(res => {
          let list = res.data.data
          list.forEach(it => {
            it._value = it.code
            it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
          })
          this.responsiblePersonList = list
        })
        .catch(errorHandler('查询失败'))
    },

    // 查询出入口列表
    getParkingAccessManageList () {
      this.$axios.post(api.getParkingAccessManageList, {})
        .then(res => {
          let list = res.data.data
          list.map(v => {
            v._label = `${v.name}/${v.location}`
          })
          this.parkingAccessManageList = list
        })
        .catch(errorHandler('查询出入口设备失败'))
    },

    // 查询班次列表
    getParkingEmergencyRouteList () {
      this.$axios.post(api.getParkingEmergencyRouteList, {})
        .then(res => {
          let list = res.data.data
          this.parkingEmergencyRouteList = list
        })
        .catch(errorHandler('查询班次列表失败'))
    },

    toMangePage () {
      this.$router.push({
        name: 'personnel-on-duty-schedule-manage'
      })
    },

    // 确认添加
    confirm () {
      if (!this.formData.deviceCode) {
        nError('请选择出入口设备')
        return false
      }
      if (!this.formData.personCode) {
        nError('请选择值班人员')
        return false
      }
      if (!this.formData.routeCode) {
        nError('请选择班次')
        return false
      }
      this.parkingAccessManageList.map(v => {
        if (v.code === this.formData.deviceCode) {
          this.formData.deviceName = v.name
        }
      })
      this.parkingEmergencyRouteList.map(v => {
        if (v.code === this.formData.routeCode) {
          this.formData.routeName = v.routeName
        }
      })
      this.responsiblePersonList.map(v => {
        if (v.code === this.formData.personCode) {
          this.formData.personName = v.name
          this.formData.personPhone = v.phone
        }
      })
      this.$axios.post(api.addParkingEmergencyRoutePlan, this.formData)
        .then(res => {
          nSuccess('添加成功')
          this.toMangePage()
        })
        .catch(errorHandler('添加失败'))
    },
    cancel () {
      this.toMangePage()
    }
  },
  watch: {}
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
}
.form-line {
  margin: 20px 0;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/PersonnelOnDuty/PersonnelOnDutySchedule/PersonnelOnDutyScheduleAdd.vue